
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_vrgzu_ru77l_9",
  "recovery": "awsui_recovery_vrgzu_ru77l_44"
};
  